exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title[data-v-4a21bebc]{margin-left:8%}.mobile[data-v-4a21bebc]{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));grid-gap:30px;padding:30px}.card[data-v-4a21bebc]{max-width:500px;height:-webkit-fill-available}.header[data-v-4a21bebc]{font-weight:700;padding-left:1.25rem;padding-top:5px;padding-bottom:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a21bebc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/os/ServiceOrderMap.vue
// module id = 1026
// module chunks = 0